import './App.css';
import React from "react";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import Footer from "./components/footer/Footer";
import TopMenu from "./components/TopMenu";
import Georgia from "./pages/tours/Gerogia";
import Home from "./pages/Home";
import {Box} from "@mui/material";
import {LanguageProvider} from "./LanguageContext";
import WayToExplorePage from "./pages/WayToExplorePage";
import Lofoten from "./pages/tours/Lofoten";
import LanguageRedirect from "./components/language/LanguageRedirect";
import ItalyComo from "./pages/tours/ItalyComo";
import Iceland from "./pages/tours/Iceland";
import Portugal from "./pages/tours/Portugal";
import ScrollToTop from "./ScrollToTop";
import DestinationsPage from "./pages/DestinationsPage";
import {NavigationProvider} from "./NavigationProvider";
import NotFound from "./pages/NotFound";
import Faroe from "./pages/tours/Faroe";
import Norway from "./pages/tours/Norway";
import ReactGA from "react-ga4";


const Content = () => {
    sessionStorage.removeItem("fromBack")

    ReactGA.initialize("G-XJSJCDQ2TG");

    return (
        <main>
            <Routes>
                <Route path="/:lang/" element={<Home/>}/>

                <Route path="/:lang/destinations" element={<DestinationsPage/>}/>
                <Route path="/:lang/way-to-explore" element={<WayToExplorePage/>}/>

                {/*tours/*/}
                <Route path="/:lang/tours/georgia" element={<Georgia/>}/>
                <Route path="/:lang/destinations/georgia" element={<Georgia/>}/>
                <Route path="/:lang/destinations/lofoten" element={<Lofoten/>}/>
                <Route path="/:lang/destinations/italy/como" element={<ItalyComo/>}/>
                <Route path="/:lang/destinations/iceland" element={<Iceland/>}/>
                <Route path="/:lang/destinations/portugal" element={<Portugal/>}/>
                <Route path="/:lang/destinations/faroe" element={<Faroe/>}/>
                <Route path="/:lang/destinations/norway" element={<Norway/>}/>

                <Route path="*" element={<NotFound/>}/>
            </Routes>
        </main>
    );
};

const App = () => {
    const topMenu = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 1000,
    };
    return (
        <Router>
            <NavigationProvider>
                <ScrollToTop/>
                <LanguageProvider>
                    <Box sx={{
                        display: "flex",
                        flexDirection: "column",
                        height: '48px',
                    }}>
                        <Box sx={topMenu}>
                            <TopMenu/>
                        </Box>
                        <Box>
                            <Content/>
                        </Box>
                        <Footer/>
                    </Box>
                </LanguageProvider>
                <LanguageRedirect/>
            </NavigationProvider>
        </Router>
    );
};

export default App;
